module.exports = __webpack_public_path__ + "img/hero_mobile.0a90ef18.png";